import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CustomSale } from '../models/custom-sale.schema';
import { Product } from '../models/product.schema';
import { Delivery } from '../models/delivery.schema';
import { ShopifySale } from '../models/shopify-sale.schema';

@Injectable({
  providedIn: 'root'
})
export class CustomPaymentsService extends ApiService {

  private readonly url = `${this.baseUrl}/custom-payments`;
  private readonly shopifyUrl = `${this.baseUrl}/shopify-sale`;
  private readonly deliveriesUrl = `${this.baseUrl}/deliveries`;
  private readonly productsUrl = `${this.baseUrl}/products`;

  async createPaymentIntent(amount: number): Promise<{ clientSecret: string }> {
    return this.http.post<{ clientSecret: string }>(
      `${this.url}/create-intent`,
      { amount }
    ).toPromise();
  }

  async createCheckoutSession(saleId: number, platform: string) {
    return this.http.post<any>(
      `${this.url}/checkout-session/${platform}`,
      { saleId }
    ).toPromise();
  }

  async getOne(saleId: string): Promise<CustomSale> {
    return this.http.get<CustomSale>(
      `${this.shopifyUrl}/${saleId}`,
    ).toPromise();
  }

  async getCustomSaleWithDeliveryInfo(primaryIdOfSale: string, platform: string): Promise<CustomSale> {
    return this.http.get<CustomSale>(
      `${this.shopifyUrl}/custom-sale/${primaryIdOfSale}/${platform}`,
    ).toPromise();
  }

  async getSaleWithDeliveryInfo(id: string|number, platform: string): Promise<any> {
    return this.http.get<any>(
      `${this.deliveriesUrl}/sale/${id}/${platform}`,
    ).toPromise();
  }

  async getProductBySku(sku: string): Promise<Product> {
    return this.http.get<any>(
      `${this.productsUrl}/sale/product/${sku}`,
    ).toPromise();
  }

  async getVaraintBySku(sku: string): Promise<any> {
    return this.http.get<any>(
      `${this.productsUrl}/sale/variant/${sku}`,
    ).toPromise();
  }

  async findDelivery(id: string): Promise<Delivery> {
    return this.http.get<Delivery> (
      `${this.deliveriesUrl}/find/delivery/${id}`,
    ).toPromise();
  }

  async sendEmailToCustomer(order: ShopifySale, platform: string): Promise<boolean> {
    const payloadData = {
      id: order.realOrderNumber,
      ddt_number: order?.actualOrderId,
      platform: platform,  
    };

    return this.http.post<boolean>(
      `${this.deliveriesUrl}/sale/email`,
      payloadData
    ).toPromise();
  }

  async findShopifyOrderDeliveries(id: string, platform: string): Promise<{ shopify_order, deliveries: Delivery[], db_order}> {
    return this.http.get<{ shopify_order, deliveries: Delivery[], db_order}>(
      `${this.deliveriesUrl}/ddt-number/${id}/${platform}`,
    ).toPromise();
  }

  async findShopifyOrderId(id: string, platform: string): Promise<{ realOrderNumber: number }> {
    return this.http.get<{ realOrderNumber: number }>(
      `${this.deliveriesUrl}/find-order-id/${id}/${platform}`,
    ).toPromise();
  }
}
